import React, { useState } from "react";
import { Box, Modal } from "@mui/material";

import { HomeConfig } from "config/homeConfig";
import SwipeableCarousel from "components/Carousel";
import { ModalContent } from ".";
import { BlackButton, ModalStyle } from "components/Styled";
import * as ga from "methods/ga";

import { ProductInfoCarouselWrapper } from "./styled";
import { useAuth } from "providers/Auth";

export default function ProductInfoCarousel() {
  const [modalOpen, setOpen] = useState("");
  const {
    auth: { userId },
    userVerify,
  } = useAuth();

  const goForm = () => {
    if (userVerify === "UNAUTHORIZED")
      document
        .getElementById("la-prairie-form")
        .scrollIntoView({ behavior: "smooth" });
    else setOpen("submited");
    ga.sendGAEvent(userId, ga.GaEventType.EXPERIENCE);
    ga.gtmButtonClick(ga.ButtonType.EXPERIENCE);
  };
  return (
    <ProductInfoCarouselWrapper>
      <div className="product_header">
        <div className="title">{HomeConfig.productInfo.title}</div>
        <div className="line" />
        <div className="subtitle">{HomeConfig.productInfo.subtitle}</div>
      </div>
      <div className="carousel">
        <SwipeableCarousel
          images={HomeConfig.productInfo.products.map(({ img }, idx) => ({
            src: img,
            label: `carousel-${idx}`,
          }))}
          height="100%"
          showAction={true}
          showActionIcon={true}
          children={HomeConfig.productInfo.products.map(
            ({ title, content }, idx) => (
              <div className="product_content" key={`carousel-content-${idx}`}>
                <div className="title">{title}</div>
                <div className="line" />
                <div className="content">{content}</div>
              </div>
            )
          )}
        />
      </div>
      <BlackButton variant="contained" onClick={goForm}>
        {ga.ButtonType.EXPERIENCE}
      </BlackButton>
      <Modal open={!!modalOpen}>
        <Box sx={ModalStyle}>
          <ModalContent type={modalOpen} setExchangeModal={setOpen} />
        </Box>
      </Modal>
    </ProductInfoCarouselWrapper>
  );
}
